import { AppState } from 'reducers';

export const getOnboardViewed = (state: AppState) => state.onboard && state.onboard.onboardViewed;
